import { ENDPOINTS } from 'utils/api/callApi'

export enum CARRIER_CONTRACT_LANES_ACTION_TYPES {
  FETCH_CARRIER_CONTRACT_LANES_REQUEST = 'FETCH_CARRIER_CONTRACT_LANES_REQUEST',
  FETCH_CARRIER_CONTRACT_LANES_SUCCESS = 'FETCH_CARRIER_CONTRACT_LANES_SUCCESS',
  FETCH_CARRIER_CONTRACT_LANES_FAILURE = 'FETCH_CARRIER_CONTRACT_LANES_FAILURE',
}

export const getCarrierContractLanes = ({
  datMarketLaneId,
  equipmentId,
  shipperApplicationId,
}: {
  datMarketLaneId: string
  equipmentId?: string
  shipperApplicationId?: string
}) => {
  const requestData = {
    endpoint: ENDPOINTS.contractLanes,
    params: {
      filters: {
        datMarketLaneId,
        equipmentId,
        shipperApplicationId,
        includes: ['dat_market_lane', 'carrier_application_offer_limits'],
      },
      perPage: 1000,
    },
  }
  return {
    type: '',
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CARRIER_CONTRACT_LANES_ACTION_TYPES),
    },
  }
}
